@if (favorite) {
  <button class="favorite-icon-button" tiime-button color="primary" icon (click)="emitRemoveFromFavorites($event)">
    <mat-icon class="favorite-icon is-favorite" fontSet="fontastic" fontIcon="icon-ic-star"></mat-icon>
  </button>
} @else {
  <button class="favorite-icon-button" tiime-button color="primary" icon (click)="emitAddToFavorites($event)">
    <mat-icon class="favorite-icon" fontSet="fontastic" fontIcon="icon-ic-star"></mat-icon>
  </button>
}
